import { render, staticRenderFns } from "./store-message.vue?vue&type=template&id=605efb9f&scoped=true&"
import script from "./store-message.vue?vue&type=script&lang=js&"
export * from "./store-message.vue?vue&type=script&lang=js&"
import style0 from "./store-message.vue?vue&type=style&index=0&id=605efb9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605efb9f",
  null
  
)

export default component.exports